/**
 * Q&A data to display as Showmore or Showless
 */
//  Geenric imports
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ShowMore } from '@re-dev/react-truncate';
import DOMPurify from "dompurify";

//  Internal imports
import './TableDetails.scss';
import Utils from '../../../utils/Utils';

const TableContent = ({ content, index, row = 3 }) => {
    const ref = useRef(null);
    const utils = new Utils();

    const toggleLines = (e, index) => {
        ref.current?.toggleLines(e);
        if (e.target.className === "toggle-show-close") {
           setTimeout(() => {
                document.getElementById(index).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
           }, 100);
        }
    }

    return (
        <ShowMore
            ref={ref}
            className="Collapse-truncate"
            lines={row}
            more={<span className='toggle-open'  onClick={(e) => toggleLines(e, index)}>... <span className='toggle-show-open'>Show more</span></span>}
            less={<span className='toggle-close' onClick={(e) => toggleLines(e, index)}> <span className='toggle-show-close'>Show less</span></span>}
        >
            <span
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(utils.markdownToHtml(content)),
                }}
            ></span>
        </ShowMore>
    )
};

TableContent.propTypes = {
    content: PropTypes.string,
    index: PropTypes.string,
    row: PropTypes.number
};

export default TableContent;